module.exports = __webpack_public_path__ + "img/kai - 에볼루션.92d3d062.png";